/**
 * Fantasy Console 0 - Waveform Selector Component
 *
 * Row of 8 buttons for selecting the active waveform type.
 */

import {
  WAVEFORM_NAMES,
  getWaveformColors,
  WAVEFORM_PATHS,
} from '../../utils/soundUtils'
import { useTheme } from '../../context/ThemeContext'
import styles from './WaveformSelector.module.css'

interface WaveformSelectorProps {
  selected: number
  onSelect: (waveform: number) => void
}

export function WaveformSelector({
  selected,
  onSelect,
}: WaveformSelectorProps) {
  const { theme } = useTheme()
  const wfColors = getWaveformColors(theme.isDark)

  return (
    <div className={styles.container}>
      <span className={styles.label}>Waveform</span>
      <div className={styles.buttons}>
        {WAVEFORM_NAMES.map((name, i) => (
          <button
            key={i}
            className={`${styles.button} ${i === selected ? styles.selected : ''}`}
            onClick={() => onSelect(i)}
            title={`${name} (${i + 1})`}
            style={i === selected ? { borderColor: wfColors[i] } : undefined}
          >
            <svg
              className={styles.waveformIcon}
              width='24'
              height='12'
              viewBox='0 0 24 12'
            >
              <path
                d={WAVEFORM_PATHS[i]}
                fill='none'
                stroke={wfColors[i]}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </button>
        ))}
      </div>
    </div>
  )
}
